<div class="scaffold-create-button">
  <button
    nbButton size="small"
    shape="round"
    class="use-icon-button"
    (click)="createData(item.new_type,info,true,false)"
    *ngIf="item.button_type == 'circle'"
    [title]="item.translation_key_label||item.heading || 'create'| translation|translationFromString | transformText :item?.text_transform_label"
    [disabled]="checkDisable()">
    <span>
      <span *ngIf="item.use_icon"
            class="create-button-icon" style="font-size:2rem;">
        <i [ngClass]="item.icon"></i>
      </span>
      <span class="create-button-heading">{{item.translation_key_label||item.heading| translation|translationFromString | transformText :item?.text_transform_label}}</span>
    </span>
  </button>
  <button
    nbButton appearance='ghost'
    status="info"
    size="large"
    (click)="createData(item.new_type,info,true,false)"
    *ngIf="item.button_type == 'ghost'"
    [title]="item.translation_key_label||item.heading || 'create'| translation|translationFromString | transformText :item?.text_transform_label" [disabled]="checkDisable()">
    <span
      *ngIf="item.use_icon"
      class="create-button-icon">
      <i [ngClass]="item.icon"></i>
    </span>
    <span class="create-button-heading">{{item.translation_key_label||item.heading| translation|translationFromString | transformText :item?.text_transform_label}}</span>
  </button>
  <button
    nbButton class="use-icon-button"
    status="primary"
    (click)="createData(item.new_type,info,true,false)"
    *ngIf="item.button_type != 'circle' && item.button_type != 'ghost'"
    [title]="item.translation_key_label||item.heading || 'create'| translation|translationFromString | transformText :item?.text_transform_label" [disabled]="checkDisable()">
    <span
      *ngIf="item.use_icon"
      class="create-button-icon">
      <i [ngClass]="item.icon"></i>
    </span>
    <span class="create-button-heading">{{item.translation_key_label||item.heading| translation|translationFromString | transformText :item?.text_transform_label}}</span>
  </button>
</div>
